import { ArrowBackRounded } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { useNavigate, useOutletContext } from "react-router-dom";

import { eboPaymentDashboardServices } from "./data";
import FOFOReport from "./FOFOReport/FOFOReport";
import FOFOCommissionMaster from "./FOFOReport/FOFOCommissionMaster";
import FOFOCashCardCollection from "./FOFOReport/FOFOCashCardCollection";
import { Roles } from "data/authData";
import MappingStores from "./COFOReport/MappingStores";
import COFOCommissionMaster from "./COFOReport/COFOCommissionMaster";
import COFOReport from "./COFOReport/COFOReport";
import SalaryPettyCash from "./COFOReport/SalaryPettyCash";

export const roleAccess = (user) =>{

    let roles = "VIEWER"
    const roleList = Roles.map((role) => role.key)

    if (user?.role?.["ADMIN"]) {
        roles = "ADMIN";
    }
    else{
        Object.keys(user?.role).forEach((role) => {
            if (roleList.includes(role)){
                roles = role
            }
        })
    }
    return {roles};
}


function EboPaymentWorking() {
    const navigate = useNavigate();
    const [currentPath, service] = useOutletContext();

    const tabComponents = {
        [eboPaymentDashboardServices.cofo.types.cofo_reports.key]: {
            ...eboPaymentDashboardServices.cofo.types.cofo_reports.key,
            component: <COFOReport />,
        },
        [eboPaymentDashboardServices.cofo.types.salary_petty_cash_master.key]: {
            ...eboPaymentDashboardServices.cofo.types.salary_petty_cash_master.key,
            component: <SalaryPettyCash />,
        },
        [eboPaymentDashboardServices.cofo.types.mapping_stores.key]: {
            ...eboPaymentDashboardServices.cofo.types.mapping_stores.key,
            component: <MappingStores />,
        },
        [eboPaymentDashboardServices.cofo.types.cofo_commission_master.key]: {
            ...eboPaymentDashboardServices.cofo.types.cofo_commission_master.key,
            component: <COFOCommissionMaster />,
        },
        [eboPaymentDashboardServices.fofo.types.fofo_reports.key]: {
            ...eboPaymentDashboardServices.fofo.types.fofo_reports.key,
            component: <FOFOReport />,
        },
        [eboPaymentDashboardServices.fofo.types.fofo_commission_master.key]: {
            ...eboPaymentDashboardServices.fofo.types.fofo_commission_master.key,
            component: <FOFOCommissionMaster />,
        },
        [eboPaymentDashboardServices.fofo.types.fofo_cash_card_collection.key]: {
            ...eboPaymentDashboardServices.fofo.types.fofo_cash_card_collection.key,
            component: <FOFOCashCardCollection />,
        },
    };

    return (
        <Box width={"100%"} p={1}>
            <Box display="flex" alignItems="center" columnGap={1} mt={2}>
                <IconButton onClick={() => navigate(-1)}>
                    <ArrowBackRounded />
                </IconButton>
                <Typography variant="h5">{service?.name}</Typography>
            </Box>
            {tabComponents?.[currentPath]?.component}
        </Box>
    );
}

export default EboPaymentWorking;
